<template>
  <div class="full">
    <div class="input-wrap" v-for="(input, index) in inputs" :key="index">
      <image-input v-model="input.value"  :label="input.label" :error="input.error" v-if="input.type === 'image'" :useParse="input.useParse" :disabled="disabled"></image-input>
      <file-input v-model="input.value"  :label="input.label" :error="input.error" v-else-if="input.type === 'file'" :useParse="input.useParse" :generateName="input.generateName" :disabled="disabled"></file-input>
      <json-input v-model="input.value"  :label="input.label" :error="input.error" v-else-if="input.type === 'json'" :disabled="disabled"></json-input>
      <v-text-field :label="input.label" v-model="input.value" @input="clearError(input)" :error-messages="input.error" :multi-line="input.type === 'textarea'" :type="input.type || 'text'" v-else></v-text-field>
    </div>
  </div>
</template>
<script>
  import ImageInput from './imageInput'
  import JsonInput from './jsonInput'
  import FileInput from './fileInput'

  export default {
    components: {
      FileInput,
      JsonInput,
      ImageInput},
    data: function () {
      return {
        inputs: []
      }
    },
    created () {
      this.init()
    },
    watch: {
      data () {
        this.init()
      }
    },
    methods: {
      formatType (type) {
        if (!type) return 'text'
        type = type.toLowerCase()
        if (type === 'string') return 'text'
        return type
      },
      init () {
        this.inputs = this.data.filter(input => {
          return !input.hide
        })
      },
      setErrors (errors) {
        for (let input of this.inputs) {
          let error = errors.find((error) => {
            return error.field === input.name
          })
          if (error) {
            this.$set(input, 'error', error.message)
          } else {
            this.$delete(input, 'error')
          }
        }
        this.$forceUpdate()
      },
      clearError (input) {
        if (input) {
          this.$delete(input, 'error')
        } else {
          for (let input of this.inputs) {
            this.$delete(input, 'error')
          }
        }
      },
      getData () {
        let data = {}
        for (let input of this.inputs) {
          data[input.name] = input.value
        }
        return data
      },
      loadData (data, clear = true) {
        this.inputs.forEach(input => {
          if (typeof data[input.name] !== 'undefined') {
            this.$set(input, 'value', data[input.name])
          } else {
            if (clear) {
              input.value = ''
            }
          }
        })
        this.$forceUpdate()
      }
    },
    props: {
      data: Array,
      disabled: Boolean
    }
  }
</script>
<style lang="scss" scoped>

</style>




// WEBPACK FOOTER //
// src/admin/components/inputs.vue